import z from "zod";
import { BarcodeFormatIdScheme, ProductVariantIdScheme } from "./ids";
import { BarcodeType } from "./enums/BarcodeType";
import { MoneyScheme } from "./money";
import { StockPolicyAssignmentScheme } from "./stockPolicy";

export const ProductVariantScheme = z.object({
  id: ProductVariantIdScheme,
  stockCount: z.number().nullable().optional(),
  stockPolicy: StockPolicyAssignmentScheme.nullable().optional(),
  shelfLocation: z.string().nullable().optional(),
  serialTracking: z.boolean().nullable().optional(),
  barcode: z
    .object({
      code: z.string(),
      type: z.enum(BarcodeType),
      format: BarcodeFormatIdScheme.nullable(),
    })
    .optional(),
  manufacturerBarcode: z.string().nullable().optional(),
  articleNumber: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  unitPrice: MoneyScheme.nullable().optional(),
  purchasePrice: MoneyScheme.nullable().optional(),
  extraFields: z.record(z.string(), z.string()).nullable().optional(),

  takeawayPrice: MoneyScheme.nullable().optional(),

  productSyncExternalId: z.string().optional(),
});

export type ProductVariant = z.infer<typeof ProductVariantScheme>;
